<template>
  <div id="app">
    <app-header></app-header>
    <div class="container">
       <router-view/>
    </div>
   

    <app-footer></app-footer>
  </div>
</template>

<script>
import Header from './components/common/header.vue'
import Footer from './components/common/footer'
export default {
  
  name: 'App',
  components: {
        'app-header':Header,
        'app-footer':Footer,
  },
}
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue